import React from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../components/Main_Logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "./navbar.css";

const NavigationBar = () => {
  return (
    <Navbar
      expand="lg"
      bg="light"
      fixed="top"                 
      className="shadow-sm py-3 custom-navbar"
    >
      <Container fluid>
        {/* ===== Left Side Logo ===== */}
        <Navbar.Brand as={Link} to="/" className="navbar-logo-left">
          <img
            src={logo}
            alt="Omeswar"
            height="35"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>

        {/* Toggle Button for Mobile */}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        {/* ===== Right Side Nav Links ===== */}
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav className="align-items-center me-3">

            {/* Dropdown: Services */}
            <NavDropdown title="Services" id="services-dropdown">
              <NavDropdown.Item as={Link} to="/bbps">BBPS</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/aeps">AEPS</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/micro-atm">Micro-ATM</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/dmt">DMT</NavDropdown.Item>
            </NavDropdown>

            {/* Other Links */}
            <Nav.Link as={Link} to="/pricing">Pricing</Nav.Link>
            <Nav.Link as={Link} to="/apidocs">API Docs</Nav.Link>

            {/* Dropdown: Company */}
            <NavDropdown title="Company" id="company-dropdown">
              <NavDropdown.Item as={Link} to="/about">About Us</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/contact">Contact Us</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/terms">Terms</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/privacy">Privacy</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/refund">Refund Policy</NavDropdown.Item>
            </NavDropdown>
          </Nav>

          {/* ===== Buttons (Right) ===== */}
          <div className="d-flex gap-2">
            {/* <Button variant="outline-primary" as={Link} to="/login">Login</Button> */}
            {/* <Button variant="outline-primary" as={Link} to="/signup">Sign Up</Button> */}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
